import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({ providedIn:'root' })
export class MessageService {
  private subject = new Subject<any>();

  get(): Observable<any> {
    return this.subject.asObservable();
  }

  send(alert: any) {
    this.subject.next(alert);
  }

  sendAlert(type: AlertTypes, message: string) {
    this.subject.next({isGenericMessage: true, type: type, message: message});
  }

  sendError(message: string, hideSpinner?: boolean) {
    if (hideSpinner) {
      this.hideSpinner();
    }
    this.subject.next({isGenericMessage: true, type: AlertTypes.Error, message: message});
  }

  sendSuccess(message: string, hideSpinner?: boolean) {
    if (hideSpinner) {
      this.hideSpinner();
    }
    this.subject.next({isGenericMessage: true, type: AlertTypes.Success, message: message});
  }
  sendSaveSuccess(entity: string) {
    this.subject.next({isGenericMessage: true, type: AlertTypes.Success, message: `${entity} saved successfully.`});
  }
  sendDeleteSuccess(entity: string) {
    this.subject.next({ isGenericMessage: true, type: AlertTypes.Success, message: `${entity} deleted successfully.` });
  }
  clearAlert() {
    this.subject.next({ isGenericMessage: true, type: AlertTypes.Clear });
  }
  clearErrorAlert() {
    this.subject.next({ isGenericMessage: true, type: AlertTypes.ClearError });
  }
  // spinner functions
  showSpinner() {
    this.send(MessageType.ProcessingOn);
  }

  hideSpinner() {
    this.send(MessageType.ProcessingOff);
  }
}

export enum MessageType {
  Authenticated = 'authenticated',
  ProcessingOn = 'processingOn',
  ProcessingOff = 'processingOff',
  Logout = 'logout',
  CustomerCreated = 'customerCreated',
  ConfigurationCreated = 'configurationCreated',
  ParameterCreated = 'parameterCreated',
  UserSQSaved = 'userSQSaved',
  FactorResetted = 'FactorReseted',
  AppCInitLoaded = 'appCInitLoaded',
  LoginRequired = 'loginRequired',
  UserDeleted = 'Delete',
  UserCreated = 'CREATED',
  HideMenu = 'HideMenu'
}
export enum AlertTypes {
  Success,
  Error,
  Warning,
  Clear,
  ClearError
}
